import * as React from 'react';
import { Box } from '@mui/material';
import { CustomAppBar } from './app-bar/AppBar';
import { RevenueCatProvider } from '../payWall/RevenueCatProvider';
import { Footer } from './footer/Footer';


export const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <RevenueCatProvider>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        zIndex: 1,
      }}
    >
      <Box
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        <CustomAppBar />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 2,
            marginTop: 4,
            paddingLeft: 4,
            paddingRight: 4,
            minHeight: 'calc(80vh)',
            width: '100%',
          }}
        >
          {children}
        </Box>

        <Footer />
      </Box>
    </Box>
  </RevenueCatProvider>
);
